module.exports = __webpack_public_path__ + "img/reduce.2e12d562.svg";